import React from "react";
import "./footer.css";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer
      className="footer skin-dark-footer"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/assets/img/footer_bg.jpg)`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
    >
      {/* ================= MAIN FOOTER ================= */}
      <div className="container">
        <div className="row">

          {/* LOGO + ABOUT */}
          <div className="col-12 col-md-4 col-lg-3 mb-4">
            <div className="footer-widget">
              <img
                src={`${process.env.PUBLIC_URL}/assets/img/the-pilot-guide-logo-white.png`}
                className="img-footer"
                alt="the-pilot-guide"
              />

              <div className="footer-add">
                <p>
                  The Pilot Guide, we are committed to providing
                  world-class aviation education and training.
                </p>
              </div>

              <div className="foot-socials">
                <ul>
                  <li><Link to="https://www.facebook.com/rightsourceaviation/" target="_blank" rel="noreferrer"><i className="fa-brands fa-facebook-f"></i></Link></li>
                  <li><Link to="https://www.linkedin.com/company/right-source-aviation/about/" target="_blank" rel="noreferrer"><i className="fa-brands fa-linkedin-in"></i></Link></li>
                  <li><Link to="https://www.instagram.com/rsa.pilot.academy/" target="_blank" rel="noreferrer"><i className="fa-brands fa-instagram"></i></Link></li>
                  <li><Link to="https://www.youtube.com/@rightsourceaviation5853" target="_blank" rel="noreferrer"><i className="fa-brands fa-youtube"></i></Link></li>
                  <li><Link to="https://linktr.ee/RightSourceAviation" target="_blank" rel="noreferrer"><i className="fa-solid fa-link"></i></Link></li>
                </ul>
              </div>
            </div>
          </div>

          {/* TEST CATEGORIES */}
          <div className="col-6 col-md-4 col-lg-2 mb-4">
            <div className="footer-widget">
              <h4 className="widget-title">Navigation</h4>
              <ul className="footer-menu">
                <li><Link to="/subscription">Meterology</Link></li>
                <li><Link to="/subscription">Regulation</Link></li>
                <li><Link to="/subscription">RTR(A)</Link></li>
                <li><Link to="/subscription">Technical</Link></li>
                <li><Link to="/subscription">Airline Prep</Link></li>
                <li><Link to="/subscription">A320/B737</Link></li>
                <li><Link to="/subscription">Cadet Pilot Program Prep</Link></li>
              </ul>
            </div>
          </div>

          <div className="col-6 col-md-4 col-lg-2 mb-4">
            <div className="footer-widget">
              <h4 className="widget-title">Our Services</h4>
              <ul className="footer-menu">
                <li><Link to="/subscription">CPL/ATPL Coaching</Link></li>
                <li><Link to="/subscription">Flight Training</Link></li>
                <li><Link to="/subscription">License Conversion</Link></li>
                <li><Link to="/subscription">Type Rating</Link></li>
                <li><Link to="/subscription">Airline Prep.</Link></li>
                <li><Link to="/subscription">Cadet Pilot Program</Link></li>
              </ul>
            </div>
          </div>
          {/* QUICK LINKS */}
          <div className="col-6 col-md-4 col-lg-2 mb-4">
            <div className="footer-widget">
              <h4 className="widget-title">Quick Links</h4>
              <ul className="footer-menu">
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/contact">Contact Us</Link></li>
              </ul>
            </div>
          </div>

          {/* DOWNLOAD APP (RESTORED – ORIGINAL STRUCTURE) */}
          <div className="col-12 col-md-4 col-lg-3 mb-4">
            <div className="footer-widget">
              <h4 className="widget-title">Download Apps</h4>

              <div className="app-wrap d-flex flex-column gap-3">

                {/* Apple Store */}
                <a
                  href="#"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="d-flex align-items-center gap-3 px-5 py-3 rounded-3 text-decoration-none footerapplink"
                  style={{
                    border: "1px solid rgba(255,255,255,0.2)",
                    transition: "0.3s",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.background = "rgba(255,255,255,0.1)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.background = "transparent")
                  }
                >
                  <div className="social-icon text-white">
                    <svg viewBox="0 0 384 512" width="30" height="30" fill="currentColor">
                      <path d="M318.7 268.7c-.2-37.6 16.8-65.8 51.5-86.5-19.4-27.7-48.7-43.2-87.6-46.2-36.8-2.9-77 21.5-91.8 21.5-15.5 0-50.6-20.5-83.2-20-43 0-83.4 25-105.7 63.9-45.1 78.2-11.5 193.3 32 256.1 21.3 30.5 46.8 64.8 80.2 63.6 32.1-1.3 44.2-20.8 83-20.8 38.8 0 49.6 20.8 83.8 20.2 34.7-.6 56.6-31.3 77.8-61.9 24.6-35.8 34.7-70.5 35.2-72.3-.8-.3-67.5-25.9-67.7-102.6zM256.3 83.4c17.7-21.5 29.6-51.4 26.3-81.4-25.5 1-56.3 16.9-74.6 38.4-16.4 18.9-30.8 49.2-26.9 78.2 28.4 2.2 57.5-14.4 75.2-35.2z" />
                    </svg>
                  </div>

                  <div className="social-caption">
                    <p className="text-uppercase text-light opacity-75 m-0" style={{ fontSize: "12px" }}>
                      Download on the
                    </p>
                    <h6 className="text-light m-0 fw-bold">App Store</h6>
                  </div>
                </a>

                {/* Google Play */}
                <a
                  href="#"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="d-flex align-items-center gap-3 px-5 py-3 rounded-3 text-decoration-none footerapplink"
                  style={{
                    border: "1px solid rgba(255,255,255,0.2)",
                    transition: "0.3s",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.background = "rgba(255,255,255,0.1)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.background = "transparent")
                  }
                >
                  <div className="social-icon text-white">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M4.335 8.615C3.981 8.616 3.641 8.757 3.39 9.008C3.14 9.259 3 9.599 3 9.954V15.307C3 15.661 3.141 16.001 3.391 16.251C3.641 16.501 3.981 16.642 4.335 16.642C4.689 16.642 5.029 16.501 5.279 16.251C5.529 16.001 5.67 15.661 5.67 15.307V9.954C5.67 9.599 5.53 9.259 5.279 9.008C5.029 8.757 4.689 8.616 4.335 8.615Z"
                        fill="white"
                      />
                      <path
                        d="M20.353 8.615C19.999 8.616 19.659 8.757 19.409 9.008C19.159 9.259 19.019 9.599 19.019 9.954V15.307C19.019 15.661 19.159 16.001 19.409 16.251C19.659 16.501 19.999 16.642 20.353 16.642C20.707 16.642 21.047 16.501 21.297 16.251C21.548 16.001 21.688 15.661 21.688 15.307V9.954C21.688 9.599 21.548 9.259 21.297 9.008C21.047 8.757 20.707 8.616 20.353 8.615Z"
                        fill="white"
                      />
                      <path
                        d="M15.676 4.539L16.864 3.095C17.1 2.81 17.06 2.39 16.78 2.15C16.5 1.91 16.08 1.95 15.835 2.243L14.535 3.821C13.843 3.501 13.09 3.336 12.328 3.339C11.566 3.342 10.814 3.512 10.125 3.837L8.86 2.252C8.62 1.96 8.2 1.92 7.92 2.15C7.64 2.39 7.6 2.81 7.818 3.089L8.99 4.558C8.371 5.055 7.872 5.685 7.528 6.4C7.184 7.116 7.005 7.899 7.003 8.693H17.684C17.682 7.894 17.501 7.106 17.153 6.387C16.806 5.668 16.301 5.036 15.676 4.539Z"
                        fill="white"
                      />
                    </svg>
                  </div>

                  <div className="social-caption">
                    <p className="text-uppercase text-light opacity-75 m-0" style={{ fontSize: "12px" }}>
                      Get it on
                    </p>
                    <h6 className="text-light m-0 fw-bold">Google Play</h6>
                  </div>
                </a>

              </div>
            </div>
          </div>


        </div>
      </div>

      {/* ================= FOOTER BOTTOM BAR ================= */}
      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-wrap footer-3col">

            {/* LEFT */}
            <div className="footer-left">
              © 2026 The Pilot Guide. All rights reserved.
            </div>

            {/* CENTER */}
            <div className="footer-center">
              Designed by{" "}
              <Link
                to="#"
                target="_blank"
                rel="noreferrer"
              >
                Metricsmart
              </Link>
            </div>

            {/* RIGHT */}
            <div className="footer-right powered-by">
              <span className="powered-text">An Initiative by</span>
              <img
                src={`${process.env.PUBLIC_URL}/assets/img/RSA-logo-white.png`}
                alt="Right Source Aviation"
              />
            </div>

          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
